import gql from "graphql-tag";
import { MemoFragment } from "./fragments";
import { createBoundMutation } from "./util";
import { Memo as MemoType } from "types";

const upsertMemo = gql`
  mutation upsertMemo($id: String, $categoryId: Int, $name: String) {
    upsertMemo(id: $id, category_id: $categoryId, name: $name) {
      ...MemoFragment
    }
  }
  ${MemoFragment}
`;

const deleteMemo = gql`
  mutation deleteMemo($id: String!) {
    deleteMemo(id: $id)
  }
`;

export namespace memoMutations {
  export interface CreateMemoArgs {
    name: string;
    categoryId: string;
  }
  export interface UpdateMemoArgs {
    id?: string;
    name?: string;
    categoryId?: string;
  }
  export interface UpsertMemoData {
    upsertMemo: MemoType;
  }

  export const CreateMemo = createBoundMutation<UpsertMemoData, CreateMemoArgs>(
    {
      mutation: upsertMemo,
      isAdd: true,
      cacheKey: "memos"
    }
  );
  export const UpdateMemo = createBoundMutation<UpsertMemoData, UpdateMemoArgs>(
    {
      mutation: upsertMemo
    }
  );
  export interface DeleteMemoArgs {
    id: string;
  }
  export interface DeleteMemoData {
    deleteMemo: string;
  }

  export const DeleteMemo = createBoundMutation<DeleteMemoData, DeleteMemoArgs>(
    {
      mutation: deleteMemo,
      isDelete: true,
      cacheKey: "memos"
    }
  );
}



// WEBPACK FOOTER //
// ./src/api/memo.ts